/**
 *
 * Copyright (c) 2019-present, wobe-systems GmbH
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * to be found in the LICENSE file in the root directory of this source tree.
 */

import draw2d from 'draw2d';

export const shapeFeedback = (shape: any) => {
  shape.installEditPolicy(new draw2d.policy.figure.AntSelectionFeedbackPolicy());
};
